import { AppRecord } from "./api.model";

export const DIVE_JOB_MODEL = "dive.job";

export class DiveJob extends AppRecord {}
